import React, { Component, Suspense } from 'react';

//UI
import Typography from "@material-ui/core/Typography";

//library
import { ToastContainer } from "react-toastify";
import { connect } from 'react-redux';
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";

//component
import { Link } from "react-router-dom";
import RequestAccount from "./_register.login";
import _verifyEmailLogin from './_verifyEmail.login';
import _submitRequest from "./_submitRequest.login";
import { setGlobalParam } from "../../reducers/reducers";

const _loginLogin = React.lazy(() => import('./_login.login'));
const _forgetLogin = React.lazy(() => import('./_forget.login'));


class Register extends Component {

    render() {
        const {show_verifyemail_component, show_successVerified_component } = this.props;
        
        if(show_verifyemail_component)
        {
            return(
            <div className="login">
                <main>
                    <ToastContainer
                        position="bottom-center"
                        newestOnTop
                        closeOnClick
                        autoClose={5000}
                        pauseOnHover
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable
                    />
                    <CssBaseline />
                    <Paper className="login-container">
                        <Suspense fallback={<div>Loading...</div>}>
                            <div className="login-form">
                                <_verifyEmailLogin />  
                            </div>
                        </Suspense>
                    </Paper>
                </main>

                  
            </div>
            );
        }

        if (show_successVerified_component) 
        {
        return (
            <div className="login">
                <main>
                    <ToastContainer
                        position="bottom-center"
                        newestOnTop
                        closeOnClick
                        autoClose={5000}
                        pauseOnHover
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable
                    />
                    <CssBaseline />
                    <Paper className="login-container">
                        <Suspense fallback={<div>Loading...</div>}>
                            <div className="login-form">
                                <_submitRequest />  
                            </div>
                        </Suspense>
                    </Paper>
                </main>
            </div>                         
        );
        }

        return (
            <div className="login">
                <main>
                    <ToastContainer
                        position="bottom-center"
                        newestOnTop
                        closeOnClick
                        autoClose={5000}
                        pauseOnHover
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable
                    />
                    <CssBaseline />
                    <Paper className="register-container">
                        <Suspense fallback={<div>Loading...</div>}>
                            <div className="register-form">
                                <RequestAccount />
                                
                            </div>
                        </Suspense>
                    </Paper>
                </main>
                {/* <_dialogLogin /> */}

                  <Typography component="p" className="text-center">
                        Already have an account? {' '} 
                        <Link to={`/login`}                  
                        ><b>Login</b>
                        </Link>
                 </Typography>
            </div>
        );

    }
}


export default connect(state => ({ ...state.reducer.login }), dispatch => ({ dispatch }))(Register);



// WEBPACK FOOTER //
// ./src/containers/Login/index.register.js